import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldX, ArrowLeft } from 'lucide-react';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        <div className="unauthorized-icon">
          <ShieldX size={48} />
        </div>
        <h1>Access Denied</h1>
        <p>
          You don't have permission to access this page. Please contact your
          administrator if you believe this is an error.
        </p>
        <button
          className="btn btn-primary"
          onClick={() => navigate('/dashboard')}
        >
          <ArrowLeft size={20} />
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;